export default "__VITE_ASSET__D2VJ_NWN__"